const AccordionDisplay = ({ open }) => {
  return (
    <span className="accordion-indicator">[{open === true ? "-" : "+"}]</span>
  );
};
AccordionDisplay.displayName = "AccordionDisplay";

module.exports = AccordionDisplay;
